import { Button } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { useRafraichirStatistiques, type CampagneNewsletter } from '../../api/newsletter.js';
import { galerieALaction } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { ErreurNewsletter } from './ErreurNewsletter.js';
import styles from './NewsletterPage.module.css';
export function StatistiquesCampagne({ campagne }: { campagne: CampagneNewsletter }) {
  const { t, i18n } = useTranslation(['regie', 'commun']);
  const { galerieSlug, galerie } = useShellContext();
  const actualiser = useRafraichirStatistiques(galerieSlug);
  const s = campagne.statistiques;
  const taux = (v: number) => (s?.delivres ? `${Math.round((v / s.delivres) * 100)} %` : '—');
  return (
    <section className={styles.section}>
      <h2>{t('regie:newsletter.campagne.statistiques')}</h2>
      <dl className={styles.grille}>
        {[
          ['delivres', s?.delivres ?? '—'],
          ['ouvertures', taux(s?.ouvertures ?? 0)],
          ['clics', taux(s?.clics ?? 0)],
          ['desinscriptions', s?.desinscriptions ?? '—'],
        ].map(([cle, valeur]) => (
          <div key={cle} className={styles.carte}>
            <dt>{t(`regie:newsletter.campagne.${cle}`)}</dt>
            <dd className={styles.chiffre}>{valeur}</dd>
          </div>
        ))}
      </dl>
      {s ? (
        <p>
          {t('regie:newsletter.campagne.releveLe', {
            date: new Intl.DateTimeFormat(i18n.language, {
              dateStyle: 'medium',
              timeStyle: 'short',
            }).format(new Date(s.luesLe)),
          })}
        </p>
      ) : null}
      {galerieALaction(galerie, 'newsletter:write') && campagne.etat === 'envoyee' ? (
        <Button
          variant="secondary"
          disabled={actualiser.isPending}
          onClick={() => actualiser.mutate(campagne.id)}
        >
          {t('regie:newsletter.campagne.rafraichir')}
        </Button>
      ) : null}
      <ErreurNewsletter erreur={actualiser.error} />
    </section>
  );
}
